import type { MessageKey } from '../../../../configuration';
import { UnreachableCaseError } from '../../../../utils/typescriptUtil';
import { HistoryAction } from './redux/types';

// Used for info popup
export const historyActionInfoMessageKeys = [
    'intl-msg:marketplace.history.action.subscription.created',
    'intl-msg:marketplace.history.action.subscription.canceled',
    'intl-msg:marketplace.history.action.resource.added',
    'intl-msg:marketplace.history.action.resource.removed',
    'intl-msg:marketplace.history.action.resource.activated',
    'intl-msg:marketplace.history.action.resource.deactivated',
    'intl-msg:marketplace.history.action.contract.renews.to.changed',
    'intl-msg:marketplace.history.action.contract.renewed',
    'intl-msg:marketplace.history.action.contract.ended',
] as const;

function actionToMessage(action: HistoryAction, resourceType?: string): MessageKey {
    switch (action) {
        case HistoryAction.SERVICE_CREATED:
            return 'intl-msg:marketplace.history.action.subscription.created';
        case HistoryAction.SERVICE_CANCELLED:
            return 'intl-msg:marketplace.history.action.subscription.canceled';
        case HistoryAction.CONTRACT_RENEWS_TO_CHANGED:
            return 'intl-msg:marketplace.history.action.contract.renews.to.changed';
        case HistoryAction.CONTRACT_RENEWED:
            return 'intl-msg:marketplace.history.action.contract.renewed';
        case HistoryAction.CONTRACT_ENDED:
            return 'intl-msg:marketplace.history.action.contract.ended';
        case HistoryAction.RESOURCE_ACTIVATION_REQUESTED:
            return resourceType === 'user'
                ? 'intl-msg:marketplace.history.action.resource.added.user'
                : 'intl-msg:marketplace.history.action.resource.added.asset';
        case HistoryAction.RESOURCE_DEACTIVATION_REQUESTED:
            return resourceType === 'user'
                ? 'intl-msg:marketplace.history.action.resource.removed.user'
                : 'intl-msg:marketplace.history.action.resource.removed.asset';
        case HistoryAction.RESOURCE_ACTIVATED:
            return resourceType === 'user'
                ? 'intl-msg:marketplace.history.action.resource.activated.user'
                : 'intl-msg:marketplace.history.action.resource.activated.asset';
        case HistoryAction.RESOURCE_DEACTIVATED:
            return resourceType === 'user'
                ? 'intl-msg:marketplace.history.action.resource.deactivated.user'
                : 'intl-msg:marketplace.history.action.resource.deactivated.asset';
        default:
            throw new UnreachableCaseError(action);
    }
}

export const getActionMessage = (action?: HistoryAction, resourceType?: string): MessageKey | undefined =>
    action && actionToMessage(action, resourceType);
